import { LogLevel } from "@azure/msal-browser";

const authConfig = {
  auth: {
    scopeUri: [process.env.REACT_APP_AZURE_SCOPE],
    tenantId: process.env.REACT_APP_AZURE_TENANT_ID,
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID,
    redirectUrl: process.env.REACT_APP_AZURE_REDIRECT,
    authority: process.env.REACT_APP_AZURE_AUTHORITY,
    // postLogoutRedirectUri: "http://localhost:3000/ndc"
  },
  cache: {
    cacheLocation: "sessionStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

export default authConfig

// export const silentRequest = {
//   scopes: ["openid", "profile"],
//   loginHint: "example@domain.net"
// };

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

// import { LogLevel } from "@azure/msal-browser";

// /**
//  * Configuration object to be passed to MSAL instance on creation.
//  * For a full list of MSAL.js configuration parameters, visit:
//  * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
//  */
// export const msalConfig = {
//     auth: {
//         clientId: 'Enter_the_Application_Id_Here', // This is the ONLY mandatory field that you need to supply.
//         authority: 'https://login.microsoftonline.com/Enter_the_Tenant_Id_Here', // Defaults to "https://login.microsoftonline.com/common"
//         redirectUri: '/', // Points to window.location.origin. You must register this URI on Azure Portal/App Registration.
//         postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
//         navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
//     },
//     cache: {
//         cacheLocation: 'sessionStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
//         storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
//     },
//     system: {
//         loggerOptions: {
//             loggerCallback: (level, message, containsPii) => {
//                 if (containsPii) {
//                     return;
//                 }
//                 switch (level) {
//                     case LogLevel.Error:
//                         console.error(message);
//                         return;
//                     case LogLevel.Info:
//                         console.info(message);
//                         return;
//                     case LogLevel.Verbose:
//                         console.debug(message);
//                         return;
//                     case LogLevel.Warning:
//                         console.warn(message);
//                         return;
//                     default:
//                         return;
//                 }
//             },
//         },
//     },
// };

// /**
//  * Scopes you add here will be prompted for user consent during sign-in.
//  * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
//  * For more information about OIDC scopes, visit:
//  * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
//  */
// export const loginRequest = {
//     scopes: []
// };

// /**
//  * An optional silentRequest object can be used to achieve silent SSO
//  * between applications by providing a "login_hint" property.
//  */
// export const silentRequest = {
//     scopes: ["openid", "profile"],
//     loginHint: "example@domain.net"
// };

// auth: {
//   production: true,
//   cpmsApiUrl: "https://ndcservices-int.cloud.aircanada.ca/cpms/",
//   azureADUrl: "https://login.microsoftonline.com/",
//   scopeUri: ["api://a9e32649-1ba9-47a9-a50f-dbd6cd015f44/.default"],
//   tenantId: "491d83df-1091-40f8-bcf9-b112f9a35fcf",
//   clientId: "a9e32649-1ba9-47a9-a50f-dbd6cd015f44",
//   redirectUrl: "https://ndcapps-int.cloud.aircanada.ca/cpmsui/",
//   umsApiUrl: "https://ndcservices-int.cloud.aircanada.ca/azureauth/",
// },
